export default "__VITE_ASSET__6ee45bd9__"